/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css, cx } from "@panda/css";
import { flex } from "@panda/patterns";
import { SystemStyleObject } from "@panda/types";

import { Category, CategoryProps, isDocumentCard } from "./Category.organism";
import React from "react";

const cardsStyle: SystemStyleObject = {
	w: "full",
	h: "full",
	rowGap: {
		base: "eds.dimension.48",
		lgDown: "eds.dimension.40",
	},
	columnGap: "eds.dimension.16",
	"& .learn-category:nth-child(1)": { flex: "1 0 70%", maxWidth: "75%" },
	"& .learn-category:nth-child(2)": { flex: "1 0 20%", maxWidth: "25%" },
	"& .learn-category:nth-child(3)": { flex: "0 0 100%" },
	"& .learn-category:nth-child(1):nth-last-child(1)": { flex: "0 0 100%", maxWidth: "none" },
	xlDown: {
		flexDir: "column",
		flexWrap: "nowrap",
		"& .learn-category:nth-child(1)": { flex: "1 0 0%", maxWidth: "none" },
		"& .learn-category:nth-child(2)": { flex: "0 1 0%", maxWidth: "none" },
		"& .learn-category:nth-child(3)": { flex: "1 0 0%" },
	},
};

export type CategoriesProps = {
	activeTab?: string | null;
	applicationFamily?: string | null;
	categories?: CategoryProps[];
};

export function Categories({ categories = [], activeTab, applicationFamily }: CategoriesProps): React.JSX.Element {
	if (!(categories[1] && categories[1].cards && categories[1].cards[0] && isDocumentCard(categories[1].cards[0]))) {
		cardsStyle["& .learn-category:nth-child(1)"] = cardsStyle["& .learn-category:nth-child(2)"] = { flex: "0 0 100%" };
		if (cardsStyle.xlDown) {
			cardsStyle.xlDown["& .learn-category:nth-child(1)"] = cardsStyle.xlDown["& .learn-category:nth-child(2)"] = {
				flex: "1 0 0%",
			};
		}
	}

	return (
		<div className={cx("learn-cards", flex({ flexWrap: "wrap" }), css(cardsStyle))}>
			{// Assigned a default value to cards so it will never be null
			categories?.map((category, i) => (
				<Category key={`category-${i}`} {...category} activeTab={activeTab} applicationFamily={applicationFamily} />
			))}
		</div>
	);
}
